import UserQuestion from '/icons/user-question.svg'
import Scalpel from '/icons/scalpel.svg'

type Props = {
  size?: number
}

export function SocialHistoryIcon({ size }: Props) {
  return <img src={UserQuestion} alt="user-question-filled" width={size} />
}

export function ProcedureIcon({ size }: Props) {
  return <img src={Scalpel} alt="scalpel" width={size} />
}
